import { render, staticRenderFns } from "./FormOne.vue?vue&type=template&id=477774a8&scoped=true&"
import script from "./FormOne.vue?vue&type=script&lang=js&"
export * from "./FormOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477774a8",
  null
  
)

export default component.exports